
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'

import Moment from 'moment'
import Config from '@/utils/config'

import COVERAPP from '@/utils/COVERAPP'

@Options ({
    computed: {
        ...mapState(['aid', 'userInfo', 'dialogData', 'activityData'])
    },
    methods: {
        ...mapMutations(['SET_DIALOGDATA', 'SET_USERINFO']),
        btnClick (btn: any) {
            if (btn.className === 'wxAuthorize-btn') {
                this.wxAuthorize()
                this.$common.track('click', '绑定微信')
            } else if (btn.className === 'download-btn') {
                this.downloadApp()
                this.$common.track('click', '下载app')
            } else if (btn.className === 'update-btn') {
                this.update()
                this.$common.track('click', '升级app')
            } else if (btn.className === 'login-btn') {
                this.login(btn)
                this.$common.track('click', '登录')
            } else if(btn.className === 'bindmobile-btn') {
                this.bindMobile(btn)
                this.$common.track('click', '绑定手机号')
            } else {
                this.SET_DIALOGDATA(null)
            }
        },
        wxAuthorize() {
            let _this = this
            COVERAPP.Method.wxAuthorize({
                callback(res: any) {
                    let data = typeof res == 'string'.toLowerCase() ? res : JSON.stringify(res)
                    if (JSON.parse(data).status == 1) {
                        const openid = JSON.parse(data).openid
                        let verifyOpenid = `${_this.userInfo.user_id.toString(36)}_${openid}_${(+Moment().format("YYYYMMDD")).toString(36)}`
                        let userInfo = JSON.parse(JSON.stringify(_this.userInfo))
                        userInfo.openid = openid
                        _this.SET_USERINFO(userInfo)
                        _this.bindWeixin(verifyOpenid)
                        _this.SET_DIALOGDATA(null)
                    }
                }
            })
        },
        bindWeixin (openid: string) {
            this.$request('/user/weixin/bind', {
                openid: openid,
                userinfo: this.userInfo
            }, 'put').then(() => {
                this.$common.toast('绑定微信成功')
            }).catch((res: any) => {
                if (res.errno == 1251) {
                    this.SET_DIALOGDATA({
                        text: '亲，您的微信号已授权，不能重复授权哦！',
                        btns: [
                            {
                                text: '确定'
                            }
                        ]
                    })
                } else {
                    this.$common.toast('绑定微信失败')
                }
            })
        },
        downloadApp () {
            // APP路径跟踪
            if (this.activityData && this.activityData.templateConfig && this.activityData.templateConfig.trackTitle && this.activityData.templateConfig.trackUrl) {
              this.$common.copyToClipborad(`${ this.activityData.templateConfig.trackTitle } ${ this.activityData.templateConfig.trackUrl } 打开封面新闻APP查看`);
              this.$common.userTrack(this.aid);
            }
            this.$common.downloadApp(this.activityData.openApp ? this.activityData.openApp.news_id : '', this.activityData.openApp && this.activityData.openApp.flag)
        },
        // 版本升级
        update () {
            if (COVERAPP.Attribute.isIOS()) {
                window.location.href = 'https://itunes.apple.com/cn/app/id1028293650'
            } else if (COVERAPP.Attribute.isAndroid()) {
                this.$common.loadjs(Config.DOWNLOAD_ADDRESS).then(()=> {
                    window.location.href = window.download_url
                })                
            }
        },
        // 登录
        login (btn: any) {
            const _this = this
            COVERAPP.Method.OpenLogin({
                callback (ret: any) {
                    let userinfo = typeof ret == 'string'.toLowerCase() ? JSON.parse(ret) : ret
                    if (!_this.$common.isEmpty(userinfo.token)) {
                        _this.$common.getUser((res: any) => {
                            _this.SET_USERINFO(res)
                            if (btn.callback) {
                                btn.callback()
                            }
                            _this.SET_DIALOGDATA(null)
                        })       																													
                    }
                }
            })
        },
        bindMobile (btn: any) {
            const _this = this
            COVERAPP.Method.bindMobile({
                callback(res: any) {
                    const result = typeof res != 'string' ? JSON.stringify(res) : res
                    if (result.indexOf('success') > -1) {
                        _this.$common.getUser((res: any) => {
                            _this.SET_USERINFO(res)
                            if (btn.callback) {
                                btn.callback()
                            }
                            _this.SET_DIALOGDATA(null)
                        })
                    }                    
                }
            })
        },
    }
})
export default class Dialog extends Vue {}
